import React from "react";
import BuildContainer from "../Common/BuildLogs/BuildContainer";

const TestSuiteBuildLogs = ({ buildId }) => {
  return <BuildContainer buildType="testSuite" buildId={buildId} />;
};

export default TestSuiteBuildLogs;
